// Importe e monte aqui os seus componentes
// Ex:
//    import Paginacao from './Paginacao/Paginacao.component.vue'
//    
//    Vue.component('paginacao', Paginacao);

import Vue from 'vue'

// POST =================================================
import Post 			from './Post/Post.vue'
import PostTitle 		from './Post/PostTitle.vue'
import PostContent 		from './Post/PostContent.vue'
import PostFooter 		from './Post/PostFooter.vue'
import PostShare 		from './Post/PostShare.vue'
import PostComment 		from './Post/PostComment.vue'

Vue.component('post', Post);
Vue.component('post-title', PostTitle);
Vue.component('post-content', PostContent);
Vue.component('post-footer', PostFooter);
Vue.component('post-share', PostShare);
Vue.component('post-comment', PostComment);


// SHARE================================================
import FacebookShare 	from './share/FacebookShare.vue'
import TwitterShare 	from './share/TwitterShare.vue'
import EmailShare 		from './share/EmailShare.vue'

Vue.component('facebook-share', FacebookShare);
Vue.component('twitter-share', TwitterShare);
Vue.component('email-share', EmailShare);

// SIDEBAR===============================================
import Busca 			from './Sidebar/Buscas.vue'
import Categorias		from './Sidebar/Categorias.vue'
import UltimosPosts		from './Sidebar/UltimosPosts.vue'

Vue.component('busca', Busca);
Vue.component('categorias', Categorias);
Vue.component('ultimos-posts', UltimosPosts);

// LazyImage
import LazyImage 		from './LazyImage.vue'

Vue.component('lazyimage', LazyImage);


// WEBPACK FOOTER //
// ./src/assets/vue/components/index.js